import { withStyles } from '@material-ui/core/styles';
import styles from './Card.styles';
import Card from './Card';

export default withStyles(styles)(Card);
